/**
 * AI Summary Generator Port
 * Interface for AI-powered document summary generation
 */

import { Output } from "ai";

export interface SummaryGenerationConfig {
  maxOutputTokens: number;
  temperature: number;
  maxRetries: number;
  retryDelayMs: number;
  output:
    | ReturnType<(typeof Output)["text"]>
    | ReturnType<(typeof Output)["json"]>;
}

export interface SummaryGenerationResult {
  summary: string;
  processingTimeMs: number;
  tokensUsed: number;
  model: string;
  generatedAt: Date;
}

export interface AIGeneratePort {
  /**
   * Generate a summary from document text
   */
  generate(
    prompt: string,
    config?: Partial<SummaryGenerationConfig>,
  ): Promise<SummaryGenerationResult>;

  /**
   * Check if the AI service is healthy and available
   */
  isHealthy(): Promise<boolean>;

  /**
   * Get available AI models
   */
  getAvailableModels(): Promise<string[]>;
}

export const DEFAULT_SUMMARY_CONFIG: SummaryGenerationConfig = {
  maxOutputTokens: 3000,
  temperature: 0.3,
  maxRetries: 3,
  retryDelayMs: 1000,
  output: Output.text(),
};
